import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_68275efa from 'nuxt_plugin_plugin_68275efa' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_a31d0246 from 'nuxt_plugin_sentryserver_a31d0246' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_48b80d55 from 'nuxt_plugin_sentryclient_48b80d55' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_4b7935c1 from 'nuxt_plugin_cookieuniversalnuxt_4b7935c1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginsrouterguard5d0ed12e_72a7cb82 from 'nuxt_plugin_pluginsrouterguard5d0ed12e_72a7cb82' // Source: ./plugins.router-guard.5d0ed12e.ts (mode: 'all')
import nuxt_plugin_pluginsaddstore1058b87b_6fb90fcb from 'nuxt_plugin_pluginsaddstore1058b87b_6fb90fcb' // Source: ./plugins.add-store.1058b87b.ts (mode: 'all')
import nuxt_plugin_gtm_2dd6e12f from 'nuxt_plugin_gtm_2dd6e12f' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtvuexroutersync_34f8df01 from 'nuxt_plugin_nuxtvuexroutersync_34f8df01' // Source: ./nuxt-vuex-router-sync.js (mode: 'all')
import nuxt_plugin_axios_74b8e819 from 'nuxt_plugin_axios_74b8e819' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_datefns_1ed7af13 from 'nuxt_plugin_datefns_1ed7af13' // Source: ./date-fns.js (mode: 'all')
import nuxt_plugin_nuxttypedvuex_b5e764a0 from 'nuxt_plugin_nuxttypedvuex_b5e764a0' // Source: ./nuxt-typed-vuex.js (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_sanitizehtml_549be24e from 'nuxt_plugin_sanitizehtml_549be24e' // Source: ../plugins/sanitize-html (mode: 'all')
import nuxt_plugin_spotlightdirective_48a09840 from 'nuxt_plugin_spotlightdirective_48a09840' // Source: ../plugins/spotlight-directive (mode: 'all')
import nuxt_plugin_blurdirective_15addb5f from 'nuxt_plugin_blurdirective_15addb5f' // Source: ../plugins/blur-directive (mode: 'all')
import nuxt_plugin_vuejsmodal_f50827f4 from 'nuxt_plugin_vuejsmodal_f50827f4' // Source: ../plugins/vue-js-modal (mode: 'client')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'client')
import nuxt_plugin_screenresolution_6e2d3012 from 'nuxt_plugin_screenresolution_6e2d3012' // Source: ../plugins/screen-resolution (mode: 'client')
import nuxt_plugin_bootstrap_0e119090 from 'nuxt_plugin_bootstrap_0e119090' // Source: ../plugins/bootstrap (mode: 'all')
import nuxt_plugin_svgicons_f087988a from 'nuxt_plugin_svgicons_f087988a' // Source: ../plugins/svg-icons (mode: 'all')
import nuxt_plugin_storesubscribers_c0effd2e from 'nuxt_plugin_storesubscribers_c0effd2e' // Source: ../plugins/store-subscribers (mode: 'all')
import nuxt_plugin_paypalpaymentprocessor_5db612a7 from 'nuxt_plugin_paypalpaymentprocessor_5db612a7' // Source: ../plugins/paypal-payment-processor (mode: 'client')
import nuxt_plugin_vuexpersist_13f465a2 from 'nuxt_plugin_vuexpersist_13f465a2' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_auth_51d0d9f7 from 'nuxt_plugin_auth_51d0d9f7' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_featureflags_4f3da13a from 'nuxt_plugin_featureflags_4f3da13a' // Source: ../plugins/feature-flags (mode: 'all')
import nuxt_plugin_mixpanel_98f97ac4 from 'nuxt_plugin_mixpanel_98f97ac4' // Source: ../plugins/mixpanel (mode: 'all')
import nuxt_plugin_googletagmanager_6ea7c4dc from 'nuxt_plugin_googletagmanager_6ea7c4dc' // Source: ../plugins/google-tag-manager (mode: 'all')
import nuxt_plugin_sentry_3c12fa56 from 'nuxt_plugin_sentry_3c12fa56' // Source: ../plugins/sentry (mode: 'all')
import nuxt_plugin_paymentsdk_653a2ebd from 'nuxt_plugin_paymentsdk_653a2ebd' // Source: ../plugins/payment-sdk (mode: 'all')
import nuxt_plugin_sappsdk_6dda2031 from 'nuxt_plugin_sappsdk_6dda2031' // Source: ../plugins/sapp-sdk (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"ScholarshipOwl - hundreds of scholarships one click away","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, user-scalable=0, minimum-scale=1.0, maximum-scale=1.0"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"stylesheet preload","as":"style","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Open+Sans:300,400,600,700,800|Raleway:300,700,800"}],"script":[{"src":"https:\u002F\u002Fgo.sunrising.tech\u002Ftrk.js","body":true},{"src":"\u002F_nuxtrf\u002Fpayment\u002Fdist\u002Fsdk.js?v=3e802bac","body":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);}})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":""}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_68275efa === 'function') {
    await nuxt_plugin_plugin_68275efa(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_a31d0246 === 'function') {
    await nuxt_plugin_sentryserver_a31d0246(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_48b80d55 === 'function') {
    await nuxt_plugin_sentryclient_48b80d55(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4b7935c1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4b7935c1(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsrouterguard5d0ed12e_72a7cb82 === 'function') {
    await nuxt_plugin_pluginsrouterguard5d0ed12e_72a7cb82(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginsaddstore1058b87b_6fb90fcb === 'function') {
    await nuxt_plugin_pluginsaddstore1058b87b_6fb90fcb(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2dd6e12f === 'function') {
    await nuxt_plugin_gtm_2dd6e12f(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtvuexroutersync_34f8df01 === 'function') {
    await nuxt_plugin_nuxtvuexroutersync_34f8df01(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_74b8e819 === 'function') {
    await nuxt_plugin_axios_74b8e819(app.context, inject)
  }

  if (typeof nuxt_plugin_datefns_1ed7af13 === 'function') {
    await nuxt_plugin_datefns_1ed7af13(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxttypedvuex_b5e764a0 === 'function') {
    await nuxt_plugin_nuxttypedvuex_b5e764a0(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_sanitizehtml_549be24e === 'function') {
    await nuxt_plugin_sanitizehtml_549be24e(app.context, inject)
  }

  if (typeof nuxt_plugin_spotlightdirective_48a09840 === 'function') {
    await nuxt_plugin_spotlightdirective_48a09840(app.context, inject)
  }

  if (typeof nuxt_plugin_blurdirective_15addb5f === 'function') {
    await nuxt_plugin_blurdirective_15addb5f(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuejsmodal_f50827f4 === 'function') {
    await nuxt_plugin_vuejsmodal_f50827f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_screenresolution_6e2d3012 === 'function') {
    await nuxt_plugin_screenresolution_6e2d3012(app.context, inject)
  }

  if (typeof nuxt_plugin_bootstrap_0e119090 === 'function') {
    await nuxt_plugin_bootstrap_0e119090(app.context, inject)
  }

  if (typeof nuxt_plugin_svgicons_f087988a === 'function') {
    await nuxt_plugin_svgicons_f087988a(app.context, inject)
  }

  if (typeof nuxt_plugin_storesubscribers_c0effd2e === 'function') {
    await nuxt_plugin_storesubscribers_c0effd2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_paypalpaymentprocessor_5db612a7 === 'function') {
    await nuxt_plugin_paypalpaymentprocessor_5db612a7(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_13f465a2 === 'function') {
    await nuxt_plugin_vuexpersist_13f465a2(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_51d0d9f7 === 'function') {
    await nuxt_plugin_auth_51d0d9f7(app.context, inject)
  }

  if (typeof nuxt_plugin_featureflags_4f3da13a === 'function') {
    await nuxt_plugin_featureflags_4f3da13a(app.context, inject)
  }

  if (typeof nuxt_plugin_mixpanel_98f97ac4 === 'function') {
    await nuxt_plugin_mixpanel_98f97ac4(app.context, inject)
  }

  if (typeof nuxt_plugin_googletagmanager_6ea7c4dc === 'function') {
    await nuxt_plugin_googletagmanager_6ea7c4dc(app.context, inject)
  }

  if (typeof nuxt_plugin_sentry_3c12fa56 === 'function') {
    await nuxt_plugin_sentry_3c12fa56(app.context, inject)
  }

  if (typeof nuxt_plugin_paymentsdk_653a2ebd === 'function') {
    await nuxt_plugin_paymentsdk_653a2ebd(app.context, inject)
  }

  if (typeof nuxt_plugin_sappsdk_6dda2031 === 'function') {
    await nuxt_plugin_sappsdk_6dda2031(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
